
/////////////////////////////////////////////////
// HANDLE THE MODAL VIEWER FUNCTIONALITY HERE
/////////////////////////////////////////////////
"use strict";
import { GLTFLoader } from "//www.gobguard.co.uk/cdn/shop/t/15/assets/GLTFLoader.js?v=46123787824158852241701790844";
//import { GLTFLoader } from "https://cdn.jsdelivr.net/npm/three@0.121.1/examples/jsm/loaders/GLTFLoader.js";


const VIEW_DEFAULT_BG_COLOUR = 0xe8e8e8;
let VIEW_CANVAS_WIDTH;
let VIEW_CANVAS_HEIGHT;

const GG_OFF = 0;
const GG_ON = 1;

let view_scene, view_camera, view_renderer, view_canvas;
let view_controls;

let view_mouthguard;

let view_hemLight;
let view_dirLight;
let view_leftLight;
let view_rightLight;
let view_backLight;

let view_rotationRate = 90; // how many degrees to rotate per second - equates to 4 seconds per revolution
let view_turntableMouthguard = true;

// get the canvas container so we can set it to the correct height based off the screen width
let view_canvasContainer = document.querySelector(".view-CanvasContainer");

let view_cameraThreeQuarterPosFar = new THREE.Vector3(-10.29, 8.94, 15.97); // for use on smaller screens
let view_cameraThreeQuarterPosClose = new THREE.Vector3(-7.96, 6.92, 12.36); // for use on bigger screens
let view_cameraThreeQuarterPos;

// set the material properties
const materialProperties = {
    OL_materialClearcoat: 1,
    OL_materialClearcoatRoughness: 0.2,
    OL_materialRoughness: 0.3,
    IL_materialClearcoat: 1,
    IL_materialClearcoatRoughness: 0.4,
    IL_materialRoughness: 0.5,
};

// used for keeping track of time for frame rate independence
let view_clock = new THREE.Clock();
let view_delta = null;

let view_modalContainer = document.getElementById("custom-modal-body-id");

const CUSTOM_SOLID_COLOUR = "solid_colour";
const CUSTOM_PATTERNED = "patterned";
const CUSTOM_CONFIGURATOR = "configurator";

let activeSection = null;
let activeStyle= null;
var CURRENT_SELECTED_IMAGE = null;

// NEW
const INNER_LAYER = 0;
const OUTER_LAYER = 1;

// holds the current outer layer and current inner layer blank settings (pattern, single colour, transparent, opaque, etc)
// use setOuterLayer() and setInnerLayer() when updating these variables as it keeps the currentThumbnail and currentInnerColour variables in sync
let view_OuterLayer;
let view_InnerLayer;
// /NEW

const uppercaseWords = str => str.replace(/^(.)|\s+(.)/g, c => c.toUpperCase());
// start
view_init();
view_animate();


// get a screenshot
function saveAsUniImage() {
    var imgData, imgNode;

    try {
        var strMime = "image/jpeg";
        imgData = view_renderer.domElement.toDataURL(strMime);
        CURRENT_SELECTED_IMAGE = imgData;

       // saveFile(imgData.replace(strMime, strDownloadMime), "test.jpg");
    } catch (e) {
        console.log(e);
        return;
    }
}

// initialise
function view_init() {
    // get the canvas
    view_canvas = document.querySelector("canvas.view-canvas");

    // create the scene
    view_scene = new THREE.Scene();

    // VIEW_CANVAS_WIDTH = window.innerWidth;
    VIEW_CANVAS_WIDTH = view_modalContainer.clientWidth;

    // VIEW_CANVAS_HEIGHT = window.innerHeight;
    view_adjustHeightBasedOffWidth(); // this sets VIEW_CANVAS_HEIGHT

    // create the camera
    view_camera = new THREE.PerspectiveCamera(
        20,
        VIEW_CANVAS_WIDTH / VIEW_CANVAS_HEIGHT,
        0.01,
        1000
    );

    // setup the renderer
    view_renderer = new THREE.WebGLRenderer({
        canvas: view_canvas,
        preserveDrawingBuffer: true,
        antialias: true,
    });
    view_renderer.setSize(VIEW_CANVAS_WIDTH, VIEW_CANVAS_HEIGHT);
    view_renderer.physicallyCorrectLights = true;
    // view_renderer.outputEncoding = THREE.sRGBEncoding;

    // the canvas needs to be positioned this way rather than in the HTML - so it appears in the correct div
    // document.body.appendChild(view_renderer.domElement);
    document.getElementById("custom-modal-body-id").appendChild(view_renderer.domElement);

    // set the scenes background colour
    view_scene.background = new THREE.Color(VIEW_DEFAULT_BG_COLOUR);

    // enable the orbit controls
    view_controls = new THREE.OrbitControls(view_camera, view_renderer.domElement);
    view_controls.mouseButtons = {
        ORBIT: THREE.MOUSE.LEFT,
        ZOOM: THREE.MOUSE.RIGHT,
        PAN: THREE.MOUSE.MIDDLE,
    };

    // load the mouthguard
    view_loadPatternMouthguard();

    // set the default camera position
    view_setCameraPosition(view_cameraThreeQuarterPos);

    // set whether you can zoom and pan by default
    view_controls.enableZoom = true;
    view_controls.enablePan = false;

    // set the min and max zoom distance
    view_controls.minDistance = 11;
    view_controls.maxDistance = 100;

    // add the lights
    view_addLights();
    setupPhysicallyCorrectFalloff();
}

// animate
function view_animate() {
    // request the next animaton frame
    requestAnimationFrame(view_animate);

    // update the controls
    view_controls.update();

    // get the time in seconds since the last getDelta() call
    view_delta = view_clock.getDelta();

    // turntable mouthguard
    if (view_mouthguard) {
        if (view_turntableMouthguard) {
            view_mouthguard.rotation.y -= (view_delta * view_rotationRate * Math.PI) / 180;
        }
    }

    // render the scene
    view_renderer.render(view_scene, view_camera);
}

// reset the mouthguards rotation
function view_resetMouthguardRotation() {
    view_mouthguard.rotation.x = 0;
    view_mouthguard.rotation.y = 0;
}

// handle the turntable checkbox
let view_turntable = document.getElementById("view-TurntableID");

document.getElementById("view-TurntableID").onclick = function () {
    // directly clicking on the checkbox registers it as being checked/unchecked, 
    // but the turntable rotating state has not been updated, so we are out of sync...
    // ...to sync, we need to either start the turntable rotating when it is checked, 
    // or stop the turntable rotating when it is unchecked
    if (view_turntable.checked) {
        view_toggleTurntable(GG_ON);
    } else {
        view_toggleTurntable(GG_OFF);
    }
};

// toggle the turntable on or off
function view_toggleTurntable(state) {
    if (state === GG_OFF) {
        view_resetMouthguardRotation();
        view_turntable.checked = false;
        view_turntableMouthguard = false;
    } else {
        view_turntable.checked = true;
        view_turntableMouthguard = true;
    }
}

// load the viewers mouthguard
function view_loadPatternMouthguard() {
    // create a mesh loader
    let loader = new GLTFLoader();

    // load the mouthguard
    //loader.load("models/uv_mouthguard.glb", function (gltf) {
    loader.load("//www.gobguard.co.uk/cdn/shop/t/15/assets/full_uv_mouthguard.glb?v=42760812738213419871701790711", function (gltf) {
        // assign the scene to the mouthguard variable
        view_mouthguard = gltf.scene;

        // create the outer layer material
        // view_mouthguard.children[1].material = new THREE.MeshPhysicalMaterial({
        view_mouthguard.children[OUTER_LAYER].material = new THREE.MeshPhysicalMaterial({
            clearcoat: materialProperties.OL_materialClearcoat,
            clearcoatRoughness: materialProperties.OL_materialClearcoatRoughness,
            roughness: materialProperties.OL_materialRoughness,
            metalness: 0,
            specularIntensity: 1,
            opacity: 1,
            side: THREE.DoubleSide,
        });

        // create the inner layer material
        // view_mouthguard.children[0].material = new THREE.MeshPhysicalMaterial({
        view_mouthguard.children[INNER_LAYER].material = new THREE.MeshPhysicalMaterial({
            clearcoat: materialProperties.IL_materialClearcoat,
            clearcoatRoughness: materialProperties.IL_materialClearcoatRoughness,
            roughness: materialProperties.IL_materialRoughness,
            opacity: 1,
            side: THREE.DoubleSide,
            color: 0xffffff,
        });

        // add the mouthguard to the scene
        view_scene.add(view_mouthguard);

        // scale the mouthguard up
        view_mouthguard.scale.set(100, 100, 100);
    });
}

// adjust the height of the canvas based off the width of the containing div
function view_adjustHeightBasedOffWidth() {
    // store the height it should be based off the width of the containing div
    if (view_modalContainer.clientWidth < 240) {
        VIEW_CANVAS_HEIGHT = 200;
    } else if (view_modalContainer.clientWidth < 340) {
        VIEW_CANVAS_HEIGHT = 250;
    } else if (view_modalContainer.clientWidth < 440) {
        VIEW_CANVAS_HEIGHT = 300;
    } else if (view_modalContainer.clientWidth < 720) {
        VIEW_CANVAS_HEIGHT = 400;
    } else if (view_modalContainer.clientWidth < 830) {
        VIEW_CANVAS_HEIGHT = 500;
    } else {
        VIEW_CANVAS_HEIGHT = 500;
    }

    // set the canvas container to the same height as the canvas
    view_canvasContainer.style.height = VIEW_CANVAS_HEIGHT + "px";

    // select the camera position to use based off the width of the containing div
    if (view_modalContainer.clientWidth < 720) {
        view_cameraThreeQuarterPos = view_cameraThreeQuarterPosFar;
    } else {
        view_cameraThreeQuarterPos = view_cameraThreeQuarterPosClose;
    }
}

// update on window resize
window.addEventListener("resize", view_onWindowResize, false);
function view_onWindowResize() {
    // adjust the height of the canvas based off the width and set the camera position
    view_adjustHeightBasedOffWidth();
    view_setCameraPosition(view_cameraThreeQuarterPos);

    // Camera frustum aspect ratio
    view_camera.aspect = view_modalContainer.clientWidth / VIEW_CANVAS_HEIGHT;

    // After making changes to aspect
    view_camera.updateProjectionMatrix();

    // Reset size
    view_renderer.setSize(view_modalContainer.clientWidth, VIEW_CANVAS_HEIGHT);

    // update the protection level text on the configurators iframe border
    updateProtectionLevelForConfigurator();
}

// set the camera position
function view_setCameraPosition(position) {
    view_camera.position.copy(position);
    // view_camera.translateZ(-10);
    view_camera.lookAt(0, 0, 0);
}

// add the lights
function view_addLights() {
    view_addHemisphereLight();
    view_addDirectionalLight();
    view_addLeftPointLight();
    view_addRightPointLight();
    view_addBackPointLight();
}

// add the hemisphere light
function view_addHemisphereLight() {
    view_hemLight = new THREE.HemisphereLight(0xffffff, 0x7f7f7f, 2);
    view_hemLight.position.set(0, 1, 0);
    view_scene.add(view_hemLight);
}

// add the directional light
function view_addDirectionalLight() {
    view_dirLight = new THREE.DirectionalLight(0xffffff, 0.2);
    view_dirLight.position.set(0, 0, 3);
    view_scene.add(view_dirLight);
}

// add the left point light
function view_addLeftPointLight() {
    view_leftLight = new THREE.PointLight(0xffffff, 8);
    view_leftLight.position.set(-10, 0, 10);
    view_scene.add(view_leftLight);
}

// add the right point light
function view_addRightPointLight() {
    view_rightLight = new THREE.PointLight(0xffffff, 8);
    view_rightLight.position.set(10, 0, 10);
    view_scene.add(view_rightLight);
}

// add the back point light
function view_addBackPointLight() {
    view_backLight = new THREE.PointLight(0xffffff, 10);
    view_backLight.position.set(0, 0, -10);
    view_scene.add(view_backLight);
}

// set the relevant lights to their physically correct falloff settings
function setupPhysicallyCorrectFalloff() {
    if (view_hemLight) view_hemLight.intensity = 1.75;
    if (view_dirLight) view_dirLight.intensity = 0.5;

    if (view_leftLight) {
        view_leftLight.decay = 2;
        view_leftLight.intensity = 50;
        view_leftLight.position.set(-6.5, 0, 5);
    }

    if (view_rightLight) {
        view_rightLight.decay = 2;
        view_rightLight.intensity = 50;
        view_rightLight.position.set(6.5, 0, 5);
    }

    if (view_backLight) {
        view_backLight.decay = 2;
        view_backLight.intensity = 10;
        view_backLight.position.set(0, 2.5, -5);
    }
}

/////////////////////////////////////////
// HANDLE THE DIFFERENT LISTS HERE
/////////////////////////////////////////
// id's into the patternList object for the textures that have alphaMap's
const ICEBERG_PATTERN_ID    = 42;
const G_CLEAR_PATTERN_ID    = 52;
const SAPPHIRE_PATTERN_ID   = 17;
const DAZZLE_PATTERN_ID     = 29;
const LADYBIRD_PATTERN_ID   = 39;
const THUNDER_PATTERN_ID    = 8;
const COSMOS_PATTERN_ID     = 25;
const BLUSH_PATTERN_ID      = 38;
const AQUAMARINE_PATTERN_ID = 10;
const PEPPERMINT_PATTERN_ID = 16;
const EMERALD_PATTERN_ID    = 21;

// store the actual textures for the different mouthguards
let view_textureList = [];

// store the actual alpha map textures for any pattern texture that has transparency
let view_alphaMapList = [];

// list the pattern textures that have transparency in them and point to their associated alpha map texture
let alphaMapList = [
    ["ptn-iceberg", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_alphaMap_iceberg.jpg?v=150773602490563115511701790779"],
    ["ptn-glitter-clear", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_alphaMap_glitter_clear.jpg?v=152804048384240848231701790779"],
    ["ptn-sapphire", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_alphaMap_sapphire.jpg?v=95356857744926903681701790781"],
    ["ptn-dazzle", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_alphaMap_dazzle.jpg?v=159646826022351077851701790778]"],
    ["ptn-ladybird", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_alphaMap_ladybird.jpg?v=142083495525154152831701790780]"],
    ["ptn-thunder", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_alphaMap_thunder.jpg?v=177458426836585549141701790781]"],
    ["ptn-cosmos", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_alphaMap_cosmos.jpg?v=7885573480284507871701790777]"],
    ["ptn-blush", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_alphaMap_blush.jpg?v=98823122269816251311701790777]"],
    ["ptn-aquamarine", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_alphaMap_aquamarine.jpg?v=178525815965648705481701790776]"],
    ["ptn-peppermint", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_alphaMap_peppermint.jpg?v=114418624319200767191701790780]"],
    ["ptn-emerald", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_alphaMap_emerald.jpg?v=30516184889921111021701790778]"],
];

// store the pattern list - specifies the cycle order - needs to match the order on the webpage
let patternList = [
    ["ptn-3d-black", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_3d_black.webp?v=111866830887904840931701790773", "3d black"],
    ["ptn-bumblebee", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_bumblebee.webp?v=80544302860584619581701790787", "bumblebee"],
    ["ptn-cosmic","//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_cosmic.webp?v=77149314331117260431701790789","cosmic"],
    
    ["ptn-ember", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_ember.webp?v=80996576097533184681701790790", "ember"],
    ["ptn-gold-rush", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_gold_rush.webp?v=85126524214588278141701790804", "gold rush"],
    ["ptn-magma", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_magma.webp?v=59011236390792172131701790808", "magma"],
    ["ptn-magpie", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_magpie.webp?v=150943387409777428261701790808", "magpie"],
    ["ptn-shimmer", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_shimmer.webp?v=15262094648715926911701790812", "shimmer"],
    ["ptn-thunder", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_thunder.webp?v=99265230793159385061701790815", "thunder"],
    ["ptn-3d-blue", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_3d_blue.webp?v=43019521643249505601701790774", "3d blue"],
    ["ptn-aquamarine", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_aquamarine.webp?v=54964902040409615891701790782", "aquamarine"],
    ["ptn-blitz", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_blitz.webp?v=120424839468806514031701790784", "blitz"],
    ["ptn-britannia", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_britannia.webp?v=28523481535868161511701790786", "britannia"],
    ["ptn-bubblegum", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_bubblegum.webp?v=94615577474160001271701790786", "bubblegum"],
    ["ptn-cloudburst", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_cloudburst.webp?v=175736947832713732261701790788", "cloudburst"],
    ["ptn-lagoon", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_lagoon.webp?v=65890502352320527401701790806", "lagoon"],
    ["ptn-peppermint", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_peppermint.webp?v=16636617634745666241701790810", "peppermint"],
    ["ptn-sapphire", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_sapphire.webp?v=15154977381944787551701790811", "sapphire"],
    ["ptn-topaz", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_topaz.webp?v=131758641530143364281701790816", "topaz"],
    ["ptn-3d-green", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_3d_green.webp?v=48639590802163346601701790774", "3d green"],
    ["ptn-apple-sour", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_apple_sour.webp?v=155008377890826604401701790782", "apple sour"],
    ["ptn-emerald", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_emerald.webp?v=23439513583196571611701790791", "emerald"],
    ["ptn-forest", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_forest.webp?v=132278947641008147261701790792", "forest"],
    ["ptn-jaydee", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_jaydee.webp?v=95729614823993114031701790805", "jaydee"],
    ["ptn-stealth", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_stealth.webp?v=153097890658177613211701790814", "stealth"],
    ["ptn-cosmos", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_cosmos.webp?v=4894121620466212571701790789", "cosmos"],
    ["ptn-sunray", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_sunray.webp?v=1948182905087663031701790815", "sunray"],
    ["ptn-tutti-frutti", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_tutti_frutti.webp?v=17345139449832732231701790817", "tutti frutti"],
    ["ptn-ballerina", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_ballerina.webp?v=22098809137210288631701790783", "ballerina"],
    ["ptn-dazzle", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_dazzle.webp?v=174081134648435843141701790790", "dazzle"],
    ["ptn-nougat", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_nougat.webp?v=147134298485833520031701790809", "nougat"],
    ["ptn-rose", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_rose.webp?v=116291954179721129791701790810", "rose"],
    ["ptn-sorbet", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_sorbet.webp?v=14166605481665213651701790812", "sorbet"],
    ["ptn-blackcurrent", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_blackcurrent.webp?v=29141380076328102721701790784", "blackcurrent"],
    ["ptn-grape", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_grape.webp?v=1649284237344524221701790804", "grape"],
    ["ptn-lupine", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_lupine.webp?v=11302723032134970131701790807", "lupine"],
    ["ptn-3d-red", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_3d_red.webp?v=150653187500333984461701790775", "3d red"],
    ["ptn-bloodshed", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_bloodshed.webp?v=45802071010322393051701790785", "bloodshed"],
    ["ptn-blush", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_blush.webp?v=135733022137565389791701790785", "blush"],
    ["ptn-ladybird", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_ladybird.webp?v=25192860060333075171701790806", "ladybird"],
    ["ptn-3d-white", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_3d_white.webp?v=127189881046223461861701790775", "3d white"],
    ["ptn-confetti", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_confetti.webp?v=58674515453061779721701790788", "confetti"],
    ["ptn-iceberg", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_iceberg.webp?v=30109324007988654621701790805", "iceberg"],
    ["ptn-mosaic", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_mosaic.webp?v=111754471261553155821701790809", "mosaic"],
    ["ptn-splatter", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_splatter.webp?v=86515861279084656901701790813", "splatter"],
    ["ptn-sprinkles", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_sprinkles.webp?v=53555458301283003301701790813", "sprinkles"],
    ["ptn-st-patrick", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_st_patrick.webp?v=121451190903544800881701790814", "st. patrick"],
    ["ptn-3d-yellow", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_3d_yellow.webp?v=182023963516736203841701790776", "3d yellow"],
    ["ptn-lemon-zest", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_lemon_zest.webp?v=97223221994300047581701790807", "lemon zest"],
    ["ptn-glitter-white", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_white.webp?v=155641787445474139981701790801", "glitter white"],
    ["ptn-glitter-black", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_black.webp?v=19606571957686708711701790792", "glitter black"],
    ["ptn-glitter-silver", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_silver.webp?v=142661304746642549851701790800", "glitter silver"],
//     ["ptn-glitter-clear", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_clear.webp?v=73233960397416937971701790793", "glitter clear"],    
    ["ptn-glitter-clear", "//www.gobguard.co.uk/cdn/shop/t/15/assets/glitter_clear_2.png?v=5331172157961705291701790714", "glitter clear"],
    ["ptn-glitter-orange", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_orange.webp?v=60476965867904108281701790796", "glitter orange"],
    ["ptn-glitter-red", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_red.webp?v=27577383401436844741701790798", "glitter red"],
    ["ptn-glitter-maroon", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_maroon.webp?v=175911676002722005191701790795", "glitter maroon"],
    ["ptn-glitter-green", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_green.webp?v=7414311020582994651701790793", "glitter green"],
    [
        "ptn-glitter-racing-green",
        "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_racing_green.webp?v=95359577326589444191701790798",
        "glitter racing green",
    ],
    ["ptn-glitter-yellow", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_yellow.webp?v=177865035676501669101701790802", "glitter yellow"],
    ["ptn-glitter-gold", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_gold.webp?v=172510913677848273601701790793", "glitter gold"],
    ["ptn-glitter-pink", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_pink.webp?v=135152960026967680651701790797", "glitter pink"],
    ["ptn-glitter-lilac", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_lilac.webp?v=104148914508517619531701790795", "glitter lilac"],
    ["ptn-glitter-purple", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_purple.webp?v=162319548473883997081701790797", "glitter purple"],
    [
        "ptn-glitter-light-blue",
        "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_light_blue.webp?v=69228971976062419491701790794",
        "glitter light blue",
    ],
    ["ptn-glitter-sky-blue", "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_sky_blue.webp?v=57617076807990386971701790800", "glitter sky blue"],
    [
        "ptn-glitter-turquoise",
        "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_turquoise.webp?v=125805175762527364571701790801",
        "glitter turquoise",
    ],
    [
        "ptn-glitter-royal-blue",
        "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_royal_blue.webp?v=158169045334500969571701790799",
        "glitter royal blue",
    ],
    [
        "ptn-glitter-navy-blue",
        "//www.gobguard.co.uk/cdn/shop/t/15/assets/textures_glitter_navy_blue.webp?v=152536282979995702821701790796",
        "glitter navy blue",
    ],
];

// store the solid colour list - specifies the cycle order - needs to match the order on the webpage
let solidColourList = [
    ["sc-white", 0xffffff, "white"],
    ["sc-black", 0x050608, "black"],
    ["sc-silver", 0x9c9db2, "silver"],
    ["sc-clear", 0xffffff, "clear"],
    ["sc-orange", 0xf15f23, "orange"],
    // ["sc-fl-orange", 0xf15927, "fl. orange"],
    // ["sc-brown", 0x964b00, "brown"], --- REMOVED
    ["sc-fl-red", 0xef4f2d, "fl. red"],
    ["sc-red", 0xef3935, "red"],
    ["sc-maroon", 0x921920, "maroon"],
    ["sc-green", 0x00a850, "green"],
    // ["sc-fl-green", 0x00a54f, "fl. green"],
    ["sc-racing-green", 0x01411f, "racing green"],
    ["sc-yellow", 0xefb81f, "yellow"],
    ["sc-fl-yellow", 0xeed312, "fl. yellow"],
    ["sc-gold", 0xcca82e, "gold"],
    ["sc-baby-pink", 0xf49dc0, "baby pink"],
    ["sc-fl-pink", 0xf0364e, "fl. pink"],
    // ["sc-lavender", 0xbdaecb, "lavender"],
    ["sc-lilac", 0x7d60aa, "lilac"],
    ["sc-purple", 0xa61e66, "purple"],
    ["sc-lt-blue", 0x00b2f0, "light blue"],
    ["sc-sky", 0x19bed4, "sky blue"],
    ["sc-turquoise", 0x00aeac, "turquoise"],
    ["sc-royal-blue", 0x2b60ad, "royal blue"],
    ["sc-navy", 0x263674, "navy blue"],
];

// store the solid colour list for the inner layer - specifies the cycle order
let solidColourList_Inner = [
    ["sc-white", 0xffffff, "white"],
    ["sc-black", 0x050608, "black"],
    ["sc-clear", 0xffffff, "clear"],
    ["sc-red", 0xef3935, "red"],
    ["sc-green", 0x00a850, "green"],
    ["sc-yellow", 0xefb81f, "yellow"],
    ["sc-royal-blue", 0x2b60ad, "royal blue"],
];

// load the pattern textures
view_loadPatternTextures();

// load the pattern textures
function view_loadPatternTextures() {
    // load the textures into an array so we just access the array rather than loading them when displayed
    if (view_textureList.length === 0) {
        let view_textureLoader = new THREE.TextureLoader();
        for (let i = 0; i < patternList.length; i++) {
            view_textureList[i] = view_textureLoader.load(patternList[i][1], (texture) => {
                // don't flip the texture in the Y direction
                texture.flipY = false;
                // texture.encoding = THREE.sRGBEncoding;
            });
        }
    }
}

// load the alpha maps
view_LoadPatternAlphaMaps();

// load the alhpa maps for textures that have some transparent sections in them
function view_LoadPatternAlphaMaps() {
    // load the alpha map textures into an array so we just access the array rather than loading them when displayed
    if (view_alphaMapList.length === 0) {
        let view_textureLoader = new THREE.TextureLoader();
        for (let i = 0; i < alphaMapList.length; i++) {
            view_alphaMapList[i] = view_textureLoader.load(alphaMapList[i][1], (texture) => {
                // don't flip the texture in the Y direction
                texture.flipY = false;
            });
        }
    }
}

/////////////////////////////////////////
// HANDLE THE MODAL FUNCTIONALITY HERE
/////////////////////////////////////////
let customSolidColourID = document.getElementById("custom-solid-colour-id");
let customPatternedID = document.getElementById("custom-patterned-id");
let customConfiguratorID = document.getElementById("custom-configurator-id");

customSolidColourID.addEventListener("click", clickedOnSolidColour);
customPatternedID.addEventListener("click", clickedOnPatterned);
customConfiguratorID.addEventListener("click", clickedConfigurator);

let customSolidColourContainer = document.getElementById("solid-colour-list-container-id");
let customPatternedContainer = document.getElementById("patterned-list-container-id");
let customConfiguratorContainer = document.getElementById("con-configurator-container-id");

// set the default mouthguard customisation section
// clickedOnSolidColour();
clickedOnPatterned();

// set the sport to combat being selected
function clickedOnSolidColour() {
    activeSection = CUSTOM_SOLID_COLOUR;
    customSolidColourContainer.style.display = "block";
    customPatternedContainer.style.display = "none";
    customConfiguratorContainer.style.display = "none";

    customSolidColourID.style.border = "3px solid var(--darkOrange)";
    customSolidColourID.style.boxShadow = "0 0 15px 2px var(--darkOrange)";
    customSolidColourID.style.fontWeight = "bold";
    document.documentElement.style.setProperty(
        "--custom-solid-colour-text-col",
        "rgb(245, 139, 30)"
    );

    // reset the other sports thumbnails
    resetNonSelectedSports(CUSTOM_SOLID_COLOUR);
  activeStyle= 'Unicolour';
}

// set the sport to stick being selected
function clickedOnPatterned() {
    activeSection = CUSTOM_PATTERNED;
    customSolidColourContainer.style.display = "none";
    customPatternedContainer.style.display = "block";
    customConfiguratorContainer.style.display = "none";

    customPatternedID.style.border = "3px solid var(--darkOrange)";
    customPatternedID.style.boxShadow = "0 0 15px 2px var(--darkOrange)";
    customPatternedID.style.fontWeight = "bold";
    document.documentElement.style.setProperty("--custom-patterned-text-col", "rgb(245, 139, 30)");

    // reset the other sports thumbnails
    resetNonSelectedSports(CUSTOM_PATTERNED);
   activeStyle= 'Pattern';
}

// set the sport to rugby being selected
function clickedConfigurator() {
    activeSection = CUSTOM_CONFIGURATOR;
    customSolidColourContainer.style.display = "none";
    customPatternedContainer.style.display = "none";
    customConfiguratorContainer.style.display = "block";

    customConfiguratorID.style.border = "3px solid var(--darkOrange)";
    customConfiguratorID.style.boxShadow = "0 0 15px 2px var(--darkOrange)";
    customConfiguratorID.style.fontWeight = "bold";
    document.documentElement.style.setProperty(
        "--custom-configurator-text-col",
        "rgb(245, 139, 30)"
    );

    // scroll to the top of the frame around the configurator
    // let top_of_configurator = document.getElementById('top-of-configurator');
    // top_of_configurator.scrollIntoView();

    // reset the other sports thumbnails
    resetNonSelectedSports(CUSTOM_CONFIGURATOR);
   // window.dispatchEvent(new Event('resize'));
   
    if($('input.sport-pl-radio-input:checked').val() == 'Pro'){
         global_ProtectionLevel = "Pro";
     }
    var script = document.createElement("script");
    script.setAttribute("type", "module");
    script.setAttribute("src", "//www.gobguard.co.uk/cdn/shop/t/15/assets/configurator.js?v=79953523146156293931701791022");
    document.getElementsByTagName("body")[0].appendChild(script);  
    activeStyle= 'Multicolour';
}

// reset the non selected sport thumbnails to being deselected
function resetNonSelectedSports(currentlySelectedSport) {
    switch (currentlySelectedSport) {
        case CUSTOM_SOLID_COLOUR:
            customPatternedID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            customPatternedID.style.boxShadow = "none";
            customPatternedID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--custom-patterned-text-col",
                "rgba(255, 255, 255, 0.5)"
            );

            customConfiguratorID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            customConfiguratorID.style.boxShadow = "none";
            customConfiguratorID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--custom-configurator-text-col",
                "rgba(255, 255, 255, 0.5)"
            );
            break;
        case CUSTOM_PATTERNED:
            customSolidColourID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            customSolidColourID.style.boxShadow = "none";
            customSolidColourID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--custom-solid-colour-text-col",
                "rgba(255, 255, 255, 0.5)"
            );

            customConfiguratorID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            customConfiguratorID.style.boxShadow = "none";
            customConfiguratorID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--custom-configurator-text-col",
                "rgba(255, 255, 255, 0.5)"
            );
            break;
        case CUSTOM_CONFIGURATOR:
            customSolidColourID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            customSolidColourID.style.boxShadow = "none";
            customSolidColourID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--custom-solid-colour-text-col",
                "rgba(255, 255, 255, 0.5)"
            );

            customPatternedID.style.border = "3px solid rgba(255, 255, 255, 0.5)";
            customPatternedID.style.boxShadow = "none";
            customPatternedID.style.fontWeight = "400";
            document.documentElement.style.setProperty(
                "--custom-patterned-text-col",
                "rgba(255, 255, 255, 0.5)"
            );
            break;
    }
}

// ******************************
// handle the customisation modal
// ******************************
// NEW
const MODAL_CLOSED = 0;
const MODAL_OPEN = 1;
let modalState = MODAL_CLOSED;
// /NEW

let modal = document.getElementById("custom-simple-modal");
let modalAddToCart = document.getElementById("custom-modal-add-to-cart");
let modalNah = document.getElementById("custom-modal-nah");
let modalOuterColourValue = document.getElementById("custom-modal-outer-colour-value-id");
// let modalProtectionValue = document.getElementById("custom-modal-protection-level-id");    OLD
let modalPriceValue = document.getElementById("custom-modal-price-value-id");

// NEW - setting up the modal having both protection toggle buttons present
let modalHighProtectionToggle = document.getElementById("custom-modal-high-protection-toggle-id");
let modalProProtectionToggle = document.getElementById("custom-modal-pro-protection-toggle-id");

let modalPreviousBtn = document.getElementById("custom-modal-prev-id");
let modalNextBtn = document.getElementById("custom-modal-next-id");

let modalHeaderPreviousBtn = document.getElementById("custom-modal-prev-inner-id");
let modalHeaderInnerColourValue = document.getElementById("custom-modal-inner-colour-value-id");
let modalHeaderNextBtn = document.getElementById("custom-modal-next-inner-id");

let modalTurntableText = document.getElementsByClassName("view-CheckboxLabel")[0];

let currentThumbnail = null;
// let currentInnerColour = solidColourList[0][0]; // set to white by default
// let currentInnerColour = solidColourList_Inner[0][0]; // set to white by default
let currentInnerColour;

// set the default inner layer blank - no need to set the outer layer blank as this happens automatically when
// clicking on a patterned or solid colour thumbnail to open the modal
setInnerLayer(solidColourList_Inner[0][0]);

modalAddToCart.addEventListener("click", addToCart);
modalNah.addEventListener("click", closeModal);

// using 'mousedown' instead of 'click' means dragging off the modal, then releasing, will not close it
window.addEventListener("mousedown", clickOutsideModal);


// NEW - setting up the modal having both protection toggle buttons present
const HIGH_MODAL_TOGGLE_ON  = 0;
const PRO_MODAL_TOGGLE_ON   = 1;  

modalHighProtectionToggle.addEventListener("click", function() {
    activateProtectionLevelToggle(HIGH_MODAL_TOGGLE_ON);
}, false);

modalProProtectionToggle.addEventListener("click", function() {
    activateProtectionLevelToggle(PRO_MODAL_TOGGLE_ON);
}, false);

// NEW - handle the hover states for the modals protection toggle buttons
let hover_colour        = 0;
let hover_border_colour = 0;

modalHighProtectionToggle.addEventListener("mouseover", function() {    
    if (!isHighSelected()) {
        hover_colour            = modalHighProtectionToggle.style.color;
        hover_border_colour     = modalHighProtectionToggle.style.borderColor;
        modalHighProtectionToggle.style.color = "rgba(0, 0, 0, 0.4)";
        modalHighProtectionToggle.style.borderColor = "rgba(0, 0, 0, 0.2)";
    }
    modalHighProtectionToggle.style.cursor = "pointer";
}, false);

modalHighProtectionToggle.addEventListener("mouseout", function() {
    if (!isHighSelected()) {
        modalHighProtectionToggle.style.color = hover_colour;
        modalHighProtectionToggle.style.borderColor = hover_border_colour;
    }
    modalHighProtectionToggle.style.cursor = "arrow";
}, false);

modalProProtectionToggle.addEventListener("mouseover", function() {
    if (!isProSelected()) {
        hover_colour            = modalProProtectionToggle.style.color;
        hover_border_colour     = modalProProtectionToggle.style.borderColor;
        modalProProtectionToggle.style.color = "rgba(0, 0, 0, 0.4)";
        modalProProtectionToggle.style.borderColor = "rgba(0, 0, 0, 0.2)";
    }
    modalProProtectionToggle.style.cursor = "pointer";
}, false);

modalProProtectionToggle.addEventListener("mouseout", function() {
    if (!isProSelected()) {
        modalProProtectionToggle.style.color = hover_colour;
        modalProProtectionToggle.style.borderColor = hover_border_colour;
    }
    modalProProtectionToggle.style.cursor = "arrow";
}, false);


// NEW
// the direction for cycling through the layer blanks (previous or next)
const PREV_BLANK = 0;
const NEXT_BLANK = 1;

// handle cycling through the inner layer and outer layer blanks
// outer layer previous
modalPreviousBtn.addEventListener("click", function() {
    advanceOuterLayerBlank(PREV_BLANK);
}, false);

// outer layer next
modalNextBtn.addEventListener("click", function() {
    advanceOuterLayerBlank(NEXT_BLANK);
}, false);

// inner layer previous
modalHeaderPreviousBtn.addEventListener("click", function() {
    advanceInnerLayerBlank(PREV_BLANK);
}, false);

// inner layer next
modalHeaderNextBtn.addEventListener("click", function() {
    advanceInnerLayerBlank(NEXT_BLANK);
}, false);

//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
//                                                                                      //
//            MODAL NAVIGATION --- ADVANCE THE INNER AND OUTER LAYER BLANKS             //
//                                                                                      //
//          THIS NAVIGATION SECTION IS ALSO WHERE THE MOUTHGUARD GETS UPDATED           //
//                                                                                      //
//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////

// set the global outer layer variable - using a function so that we can keep currentThumbnail in sync as this may be used by Ruchi
function setOuterLayer(blank) {
    view_OuterLayer = blank;
    currentThumbnail = view_OuterLayer;
}

// set the global inner layer variable - using a function so that we can keep currentInnerColour in sync as this may be used by Ruchi
function setInnerLayer(blank) {
    view_InnerLayer = blank;
    currentInnerColour = view_InnerLayer;
}

// *********************************************************************
//                              INNER LAYER
// *********************************************************************
// cycle to the next or previous INNER layer blank based on the direction passed in
function advanceInnerLayerBlank(direction) {
    // make sure the modal is open - stops keyboard navigation affecting the layer when the modal is closed
    if(modalState === MODAL_OPEN) {
        // there is only a separate inner layer blank for PRO protection level
        if (view_protectionLevel === "pro") {
            // handle the correct direction we're moving in
            if(direction === PREV_BLANK) {
                for (let i = 0; i < solidColourList_Inner.length; i++) {
                    if (view_InnerLayer === solidColourList_Inner[i][0]) {
                        if (i > 0) {
                            setInnerLayer(solidColourList_Inner[i - 1][0]);
                        }
                        break;
                    }
                }

            } else {    // direction === NEXT_BLANK
                for (let i = 0; i < solidColourList_Inner.length; i++) {
                    if (view_InnerLayer === solidColourList_Inner[i][0]) {
                        if (i < solidColourList_Inner.length - 1) {
                            setInnerLayer(solidColourList_Inner[i + 1][0]);
                        }
                        break;
                    }
                }
            }

            // update the mouthguard
            view_updateSelectedMouthguard();
        }
    }
}

// *********************************************************************
//                              OUTER LAYER
// *********************************************************************
// cycle to the next or previous OUTER layer blank based on the direction passed in
function advanceOuterLayerBlank(direction) {
    // make sure the modal is open - stops keyboard navigation affecting the layer when the modal is closed
    if(modalState === MODAL_OPEN) {
        // assign the correct list to search
        let list = getListToTraverse();

        // handle the correct direction we're moving in
        if(direction === PREV_BLANK) {
            for (let i = 0; i < list.length; i++) {
                if (view_OuterLayer === list[i][0]) {
                    if (i > 0) {
                        setOuterLayer(list[i - 1][0]);
                    } else {
                        setOuterLayer(list[0][0]);
                    }
                    break;
                }
            }

        } else {    // direction === NEXT_BLANK
            for (let i = 0; i < list.length - 1; i++) {
                if (view_OuterLayer === list[i][0]) {
                    if (i < list.length - 1) {
                        setOuterLayer(list[i + 1][0]);
                    } else {
                        setOuterLayer(list[list.length][0]);
                    }
                    break;
                }
            }
        }

        // update the mouthguard
        view_updateSelectedMouthguard();
    }
}

// get the list we should be looking through
function getListToTraverse() {
    // return the list we should traverse based on the active section
    if (activeSection === CUSTOM_SOLID_COLOUR) {
        return solidColourList;
    } else {    // activeSection === CUSTOM_PATTERNED
        return patternList;
    }
}
// /NEW





// *********************************************************************
//      NEW - setting up the toggleable switches for protection levels on the modal
// *********************************************************************
function activateProtectionLevelToggle(whichToggle) {
    // toggle the protection level on the sports page itself
    if(whichToggle === HIGH_MODAL_TOGGLE_ON) {
        protectionLevel_High.checked = true;
    } else {
        protectionLevel_Pro.checked = true;
    }

    // update the protection level toggles for the modal and update the mouthguard details and visuals
    view_setProtectionLevel();
    view_updateSelectedMouthguard();

    // update the look of the protection level buttons on their state changes
    modal_UpdateProtectionLevelBtnsStateChanges();
}

const DESELECT_TOGGLE    = 0
const SELECT_TOGGLE      = 1

// update the modals protection level buttons so they toggle between a selected and unselected look
function modal_UpdateProtectionLevelBtnsStateChanges() {
    if (isHighSelected()) {
        modal_HighProtectionToggle(SELECT_TOGGLE);
        modal_ProProtectionToggle(DESELECT_TOGGLE);
    } else {
        modal_ProProtectionToggle(SELECT_TOGGLE);
        modal_HighProtectionToggle(DESELECT_TOGGLE);        
    }
}

// select or deselect the HIGH protection toggle on the modal depending on the state passed
function modal_HighProtectionToggle(state) {
    if(state === SELECT_TOGGLE) {
        modalHighProtectionToggle.style.fontWeight = "bold";
        modalHighProtectionToggle.style.color = "rgb(48, 53, 73)";
        modalHighProtectionToggle.style.backgroundColor = "rgba(0, 0, 0, 0.1)";
        modalHighProtectionToggle.style.borderColor = "rgba(0, 0, 0, 0.1)";
    } else {
        modalHighProtectionToggle.style.fontWeight = "normal";
        modalHighProtectionToggle.style.backgroundColor = "#eee";
        modalHighProtectionToggle.style.color = "rgba(0, 0, 0, 0.1)";
    }
}

// select or deselect the PRO protection toggle on the modal depending on the state passed
function modal_ProProtectionToggle(state) {
    if(state === SELECT_TOGGLE) {
        modalProProtectionToggle.style.fontWeight = "bold";
        modalProProtectionToggle.style.color = "rgb(48, 53, 73)";
        modalProProtectionToggle.style.backgroundColor = "rgba(0, 0, 0, 0.1)";
        modalProProtectionToggle.style.borderColor = "rgba(0, 0, 0, 0.1)";
    } else {
        modalProProtectionToggle.style.fontWeight = "normal";
        modalProProtectionToggle.style.backgroundColor = "#eee";
        modalProProtectionToggle.style.color = "rgba(0, 0, 0, 0.1)";
    }
}









// handle switching the basket graphic on the add to cart button of the modal
modalAddToCart.addEventListener("mouseenter", displayWhiteBasket);
modalAddToCart.addEventListener("mouseleave", displayDarkBlueBasket);

function displayDarkBlueBasket() {
    modalAddToCart.style.backgroundImage = "url('//www.gobguard.co.uk/cdn/shop/t/15/assets/dark_blue_basket.png?v=12258872354288682541701790703')"; 
    
}

function displayWhiteBasket() {
    modalAddToCart.style.backgroundImage = "url('//www.gobguard.co.uk/cdn/shop/t/15/assets/white_basket.png?v=70208241875876884431701790828')"; 
}

// handle switching the cross graphic on the close button of the modal
modalNah.addEventListener("mouseenter", displayWhiteCross);
modalNah.addEventListener("mouseleave", displayDarkBlueCross);

function displayWhiteCross() {
    modalNah.style.backgroundImage = "url('//www.gobguard.co.uk/cdn/shop/t/15/assets/white_cross.png?v=115086439683638000301701790828')"; 
}

function displayDarkBlueCross() {
    modalNah.style.backgroundImage = "url('//www.gobguard.co.uk/cdn/shop/t/15/assets/dark_blue_cross.png?v=111919240795609190701701790703')"; 
}

// event delegation on mouse click for solid colour container
document.getElementById("solid-colour-list-container-id").addEventListener(
    "click",
    function (e) {
        // check to see if we are looking at a solid colour mouthguard thumbnail
        if (e.target.nodeName === "IMG") {
            // flag which thumbnail we clicked on and open the modal
            // currentThumbnail = e.target.id;
            setOuterLayer(e.target.id);
            openModal();
        }
    },
    true
);

// event delegation on mouse click for patterned container
document.getElementById("patterned-list-container-id").addEventListener(
    "click",
    function (e) {
        // check to see if we are looking at a patterned mouthguard thumbnail
        if (e.target.nodeName === "IMG") {
            // flag which thumbnail we clicked on and open the modal
            // currentThumbnail = e.target.id;
            setOuterLayer(e.target.id);
            openModal();
        }
    },
    true
);

// NEW
//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
//                                                                                      //
//                                  OPEN THE MODAL                                      //
//                                                                                      //
//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
function openModal() {
    // flag that we've opened the modal
    modalState = MODAL_OPEN;

    // set the protection level for the modal
    view_setProtectionLevel();

    // set the inner colour of the mouthguard to white when opening the modal
    // setInnerLayer(solidColourList_Inner[0][0]);

    // update the mouthguard
    view_updateSelectedMouthguard();

    // setup modals styles and sizes
    modal_setModalStylesAndSizes();

    // display the modal
    modal.style.display = "block";

    // refresh the drawing of the canvas
    view_onWindowResize();
}
// /NEW

// handle adding the item to the cart, then close the modal
function addToCart() {
    // set the relevant list we want to search
    let searchList;
    if (activeSection === CUSTOM_SOLID_COLOUR) {
        searchList = solidColourList;
    } else if (activeSection === CUSTOM_PATTERNED) {
        searchList = patternList;
    }

    // find the index for the current thumbnail in the list
    let index = null;
    for (let i = 0; i < searchList.length; i++) {
        // if (currentThumbnail === searchList[i][0]) {
        if (view_OuterLayer === searchList[i][0]) {
            index = i;
            break;
        }
    }

    // display the added to basket toast message, update the basket counter, add the mouthguard
    // to the order form, etc.
   
    if(index !== null) {
      // shopify add to cart
      var level =  jQuery('input[name="sportProtectionLevelRadio"]:checked').val();    
      
      var biolanIsert = '';
      if(jQuery('#sport-biolan-id').is(':checked')){
        // jQuery('#biolanIsert').val('Yes');
        biolanIsert = 'Yes';
             } else{
        // jQuery('#biolanIsert').val('No');
                biolanIsert = 'No';
        }

      // force biolon off
      biolanIsert = 'No';

      // TRIED REMOVING BIOLON INSERT FROM THE CART, BUT DOESN'T WORK - DONE IN 2 SEPARATE PLACES
      // IT SEEMS WE'D NEED TO CHANGE THE INDIVIDUAL PRODUCTS VARIANT ENTRY TO REMOVE THE BIOLON ENTRY THERE FOR IT TO WORK
      var variant_text = ''+level+' / '+activeStyle+ ' / '+biolanIsert;
      // var variant_text = ''+level+' / '+activeStyle;
      jQuery("#ProductSelect-variant option:contains('"+variant_text+"')").attr('selected', 'selected');
      
      var selected_color = jQuery('#custom-modal-outer-colour-value-id').text();
      selected_color= uppercaseWords(selected_color);
      selected_color= selected_color.replace("3d", "3D");      
      jQuery('#selectedColor').val(selected_color);
      
      if(activeStyle == 'Unicolour'){
        saveAsUniImage();
      }

      if(CURRENT_SELECTED_IMAGE !== null) {
        CURRENT_SELECTED_IMAGE = CURRENT_SELECTED_IMAGE.replace("textures_", ""); 
      }
      
// *** REMOVED ***
// The line below has been commented out because of the following situation:
// The line below uses the screenshot of the product that was taken above (see the saveAsUniImage() call) as a thumbnail in the basket.
// However, this thumbnail cannot be used on the checkout page, for some unknown reason,
// which means the default thumbnail for the product variant will be used here instead.
//
// As such, the devs added an extra text string to the checkout page that the user can use to link to the actual thumbnail that was captured, 
// to see what they ordered.
// This is NOT IDEAL as a work-around, and it looks bad in general when the basket thumbnails don't match the ones on the checkout page.
//
// To get around this limitation in a more sensible manner we've added generic thumbnails to each of the variants on the sports product page.
// Doing this means the thumnails in the basket and on the checkout page will match each other at least, the downside is they don't match what the product is.
//
//       jQuery('#selectedImage').val(CURRENT_SELECTED_IMAGE);
      
      var sportType= jQuery('.sport-dial.active').attr('data-value');
      jQuery('#sportstype').val(sportType);
     
       let item = searchList[index][2].toUpperCase();
       var innercolour= currentInnerColour.replace("sc-", "");
		 innercolour= innercolour.replace("-", " ");       
        innercolour= uppercaseWords(innercolour);
      innercolour= innercolour.replace("3d", "3D");
      // only have an inner colour with a pro level mouthguard now
      // if(activeStyle == 'Unicolour' || level == "Pro"){
      if(level == "Pro"){
        
          jQuery('#innercolour').val(innercolour);
      }
      else{
         jQuery('#innercolour').val('');
      }
      
        addItem(item);
     
       
    } else {
    }

    // console.log("Inner Layer: ", view_InnerLayer);
    // console.log("Outer Layer: ", view_OuterLayer);
  
    // console.log("OLD Inner Layer: ", currentInnerColour);
    // console.log("OLD Outer Layer: ", currentThumbnail);

    // close the modal
    // closeModal();
}


function addItem(item) {
  // console.log($('#ajax-add-tocart').serialize());

  // console.log("ITEM: ", item);
  
     $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            dataType: 'json', 
            data: $('#ajax-add-tocart').serialize(),
           success: function(){         
              let vall = item.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();                 
            });
              // console.log(vall);
               Toast.show(vall + ' added to your basket', "added-to-basket");
             $('#ajax-add-tocart')[0].reset();
             // currentInnerColour = '';
             //currentThumbnail = '';
             // get updated qty
               $.ajax({
                type: 'GET',
                url: '/cart.json',
                dataType: 'json',
                success: function(data) { 
                    var item_count = data.item_count;
                  
                  $('#desktop-cart-item').html(item_count);
                  $('#mobile-cart-item').html(item_count);
                }
              });
           },
           error: function(){
                Toast.show("ERROR - No valid mouthguard selected!", "error");
           }
         });
}
// close the modal
function closeModal() {
    modal.style.display = "none";
    // currentInnerColour = '';
    // currentThumbnail = '';
    modalState = MODAL_CLOSED;
}

// close the modal if you click outside the modal body
function clickOutsideModal(e) {
    if (e.target == modal) {
        closeModal();
    }
}

const UNICOLOUR_BASE_PRICE = 50;
const PATTERN_BASE_PRICE = 60;

const BIOLON_WHITE = "white";
const BIOLON_GREYED_OUT = "greyed_out";

// get the configurators iframe border element
let con_iframeBorder = document.getElementsByClassName("con-iframe-border")[0];

let protectionLevel_High = document.getElementById("sport-high-id");
let protectionLevel_Pro = document.getElementById("sport-pro-id");
let protectionLevel_Biolan = document.getElementById("sport-biolan-id");
let protectionLevel_BiolanText = document.getElementById("sport-biolan-text-id");
let protectionLevel_BiolanContainer = document.getElementById("sport-biolan-container-id");

// handle clicks on the different protection levels
protectionLevel_High.addEventListener("click", setHighProtectionLevel);
protectionLevel_Pro.addEventListener("click", setProProtectionLevel);
protectionLevel_Biolan.addEventListener("click", setBiolan);

// set the protection level to 'high' by default
let view_protectionLevel = null;
setHighProtectionLevel();

// TURN OFF - the biolon container as we're not using it now - comment out this following line to re-enable the biolon option
protectionLevel_BiolanContainer.style.display = "none";

// return the protection level string based on when level is selected
function getProtectionLevelForMouthguard() {
    let plString;

    if (isHighSelected()) {
        if(window.innerWidth > 830) {
            plString = "High Protection";
        } else {
            plString = "High";
        }
    } else if (isProSelected()) {
        if(window.innerWidth > 830) {
            plString = "Pro Protection";
        } else {
            plString = "Pro";
        }
    }

    if (isBiolanChecked()) {
        if(window.innerWidth > 830) {
            plString += " with Biolon Insert";
        } else {
            plString += " with Biolon";
        }
    }

    return plString;
}

// return the calculated price based on what protection level is selected
function getCalculatedPriceForMouthguard(basePrice) {
//     let priceAmount = basePrice;

//     if (isProSelected()) {
//         priceAmount += 5;
//     }

//     if (isBiolanChecked()) {
//         priceAmount += 5;
//     }

  
      var level =  jQuery('input[name="sportProtectionLevelRadio"]:checked').val();    
      
      var biolanIsert = '';
      if(jQuery('#sport-biolan-id').is(':checked')){
        // jQuery('#biolanIsert').val('Yes');
        biolanIsert = 'Yes';
             } else{
        // jQuery('#biolanIsert').val('No');
                biolanIsert = 'No';
        }

      // force biolon off
      biolanIsert = 'No';
  
      // TRIED REMOVING BIOLON INSERT FROM THE CART, BUT DOESN'T WORK - DONE IN 2 SEPARATE PLACES
      // IT SEEMS WE'D NEED TO CHANGE THE INDIVIDUAL PRODUCTS VARIANT ENTRY TO REMOVE THE BIOLON ENTRY THERE FOR IT TO WORK
      var variant_text = ''+level+' / '+activeStyle+ ' / '+biolanIsert;
      // var variant_text = ''+level+' / '+activeStyle;
      $("#ProductSelect-variant option").each(function() {  
        if($(this).text() == variant_text){          
          $("#ProductSelect-variant").val($(this).val());
        }
      });
     // jQuery("#ProductSelect-variant option:contains('"+variant_text+"')").attr('selected', 'selected');
      let priceAmount = jQuery('#ProductSelect-variant option:selected').attr('data-custom-price');
    return priceAmount;
}

// return whether the high protection level is selected or not
function isHighSelected() {
    return protectionLevel_High.checked;
}

// return whether the pro protection level is selected or not
function isProSelected() {
    return protectionLevel_Pro.checked;
}

// return whether the biolan insert is selected or not
function isBiolanChecked() {
    return protectionLevel_Biolan.checked;
}

// make sure the mouthguard layer IS NOT set to transparent
function setLayerToOpaque(layer) {
    view_mouthguard.children[layer].material.transmission = 0;
    view_mouthguard.children[layer].material.thickness = 0;
    view_mouthguard.children[layer].material.opacity = 1;
}

// make sure the mouthguard layer IS set to transparent
function setLayerToTransparent(layer) {
    view_mouthguard.children[layer].material.color.set(0xffffff);
    view_mouthguard.children[layer].material.transmission = 0.4;
    view_mouthguard.children[layer].material.thickness = 0;
    view_mouthguard.children[layer].material.opacity = 1;
}

const GG_KEY_ESCAPE = 27;   // close the modal
const GG_KEY_T      = 84;   // toggle the turntable feature on and off
const GG_KEY_A      = 65;   // cycle to previous mouthguard in modal mode
const GG_KEY_D      = 68;   // cycle to next mouthguard in modal mode
const GG_KEY_Q      = 81;   // cycle to previous inner colour
const GG_KEY_E      = 69;   // cycle to next inner colour

// handle keyboard input - using THREE.js to handle it
document.addEventListener("keydown", onDocumentKeyDown, false);

function onDocumentKeyDown(event) {
    let keyCode = event.which;

    switch (keyCode) {
        case GG_KEY_ESCAPE:
            closeModal();
            break;
        case GG_KEY_A:
            advanceOuterLayerBlank(PREV_BLANK);
            break;
        case GG_KEY_D:
            advanceOuterLayerBlank(NEXT_BLANK);
            break;
        case GG_KEY_Q:
            advanceInnerLayerBlank(PREV_BLANK);
            break;
        case GG_KEY_E:
            advanceInnerLayerBlank(NEXT_BLANK);
            break;
        case GG_KEY_T:
            // if the turntable is set to on (checked), turn it off, and vice versa
            if (view_turntable.checked) {
                view_toggleTurntable(GG_OFF);
            } else {
                view_toggleTurntable(GG_ON);
            }
            break;
    }
}

// *********************************************************************
// HANDLE UPDATING THE PROTECTION LEVEL AND PRICE FOR THE CONFIGURATOR
// *********************************************************************

// set the colour of the biolon checkbox text to white if it is available or greyed out if it is not available
function setBiolanTextColour(colour) {
    if(colour === BIOLON_WHITE) {
        protectionLevel_BiolanText.style.color = "rgba(255, 255, 255, 1)";
    } else if(colour === BIOLON_GREYED_OUT) {
        protectionLevel_BiolanText.style.color = "rgba(255, 255, 255, 0.1)";
    }
}

// make sure we have set the protection level on the configurators iframe at least once
// and we've synced the number of colours being used on the configurator mouthguard
updateProtectionLevelForConfigurator();

// handle the functionality when clicking on the high protection level radio button
function setHighProtectionLevel() {
    view_protectionLevel = "high";
    setBiolanTextColour(BIOLON_GREYED_OUT);
    updateGlobalProtectionLevel();

    // uncheck the biolon checkbox if it is already checked and we're selecting high protection level
    if(isBiolanChecked()) {
        protectionLevel_Biolan.checked = false;
    }

    updateProtectionLevelForConfigurator();
}

// handle the functionality when clicking on the pro protection level radio button
function setProProtectionLevel() {
    view_protectionLevel = "pro";
    setBiolanTextColour(BIOLON_WHITE);
    updateGlobalProtectionLevel();
    updateProtectionLevelForConfigurator();
}

// handle the functionality when clicking on the biolan checkbox
function setBiolan() {
    // don't allow the biolon checkbox to be checked if the high protection level is currently set
    if(view_protectionLevel === "high") {
        protectionLevel_Biolan.checked = false;
        setBiolanTextColour(BIOLON_GREYED_OUT);
    }
  
    updateProtectionLevelForConfigurator();
}

// set the global_ProtectionLevel variable in the configurator.html file so the configurator.js file knows what is selected
function updateGlobalProtectionLevel() {
    global_ProtectionLevel = view_protectionLevel;
}

// update the configurators iframe border ::before pseudo element with the current level of protection
// we need to check how many outer layer colours the mouthguard on the configurator has,
// which requires a time delay to sync correctly
function updateProtectionLevelForConfigurator() {
    updateNumCols();
}

// update with the current number of colours used on the mouthguard
// need to wait for a time delay before getting the number of colours so 
// that the prices can be synced correctly
async function updateNumCols() {
    await sleepForNumColUpdate(100);
    let numCols;
    numCols = global_Colours;
  // console.log('updateee');
    doUpdateProtectionLevelForConfiguratorNow(numCols);
}

// make sure we sleep for the specified time
function sleepForNumColUpdate(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

// handle the update to the protection level for the configurator after the imposed delay
function doUpdateProtectionLevelForConfiguratorNow(numCols) {
  // console.log('num',numCols);
    let basePrice;

    // set the base price based on the number of outer layer colours being used
    if(numCols == 2) {
        basePrice = 60;
    } else if(numCols == 1) {
        basePrice = 50;
    } else {
        basePrice = "ERROR!"
    }
  
 

    // update the iframe border ::before pseudo element with the calculated price based off
    // the amount of outer layer colours being used and the current protection level
    con_iframeBorder.setAttribute("data-before", getProtectionLevelForMouthguard() 
        + " - " + getCalculatedPriceForMouthguard(basePrice));
}

//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
//                                                                                      //
//                              GENERAL UTILITY FUNCTIONS                               //
//                                                                                      //
//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
// set the protection level
function view_setProtectionLevel() {
    if (isHighSelected()) {
        setHighProtectionLevel();
    } else if (isProSelected()) {
        setProProtectionLevel();
    }
}

// update the mouthguard
function view_updateSelectedMouthguard() {
    let index = null;
    let index_inner = null;

    // make sure the mouthguard layers are set to opaque by default
    setLayerToOpaque(OUTER_LAYER);
    setLayerToOpaque(INNER_LAYER);

    // make sure any alphaMap setting is removed
    disableLayersAlphaMap();

    // are we using a HIGH or PRO protection level
    if (view_protectionLevel === "high") {
        // make sure the modal header reflects that there is no inner layer available for HIGH protection
        modal_setNoInnerLayerHeader(); 

        // are we in the PATTERNED or SOLID COLOUR section
        if(activeSection === CUSTOM_PATTERNED) {
            // get the index of the currently selected outer layer pattern blank
            index = getCurrentBlankIndex(view_OuterLayer, patternList);
                   
            // as were in HIGH - set the outer layer and inner layer pattern to be the same
            update_PatternedLayer(OUTER_LAYER, view_textureList[index]);
            update_PatternedLayer(INNER_LAYER, view_textureList[index]);
            
            // handle the different textures that have transparent sections in them
            view_handleTexturesWithTransparency(OUTER_LAYER, index);
            view_handleTexturesWithTransparency(INNER_LAYER, index);

            // set the modals protection level, price and blank
            modal_set_ProtectionLevel_Price_Blank(PATTERN_BASE_PRICE, patternList[index][2]);

        } else {    // HIGH - SOLID COLOUR
            // get the index of the currently selected outer layer solid colour blank
            index = getCurrentBlankIndex(view_OuterLayer, solidColourList);

            // set the outer layer colour/transparency
            // checking for index of 3 because we're using the full list of colours as we're dealing with the outer layer
            if(index === 3) {
                update_SolidColourLayer(OUTER_LAYER, solidColourList[index][1], true);
            } else {
                update_SolidColourLayer(OUTER_LAYER, solidColourList[index][1], false);
            }

            // set the inner layer colour - we're not setting transparency for this layer because we lose the teeth outline if we do
            // we have to update the inner layer with the full list of colours as technically there is no inner layer
            // and this inner layer is just copying the outer layer colour
            update_SolidColourLayer(INNER_LAYER, solidColourList[index][1], false);

            // set the modals protection level, price and blank
            modal_set_ProtectionLevel_Price_Blank(UNICOLOUR_BASE_PRICE, solidColourList[index][2]);

        }
    } else {    // PRO protection level
        // make sure the modal header reflects the current inner layer colour
        modal_setInnerLayerColourHeader();

        // are we in the PATTERNED or SOLID COLOUR section
        if(activeSection === CUSTOM_PATTERNED) {
            // get the index for the outer layer patterned blank and the inner layer solid colour blank
            index = getCurrentBlankIndex(view_OuterLayer, patternList);
            index_inner = getCurrentBlankIndex(view_InnerLayer, solidColourList_Inner);

            // set the outer layer pattern
            update_PatternedLayer(OUTER_LAYER, view_textureList[index]);

            // set the inner layer colour and its transparency if clear is selected
            // checking for index of 2 because we're using the reduced list of colours as we're dealing with an actual inner layer
            if(index_inner === 2) {
                // the inner layer is clear, so match it to the outer layer pattern
                update_PatternedLayer(INNER_LAYER, view_textureList[index]);
                // update_SolidColourLayer(INNER_LAYER, solidColourList_Inner[index_inner][1], true);

            } else {
                update_SolidColourLayer(INNER_LAYER, solidColourList_Inner[index_inner][1], false);
            }

            // handle the different textures that have transparent sections in them - only for the outer layer
            view_handleTexturesWithTransparency(OUTER_LAYER, index);

            // set the modals protection level, price and blank
            modal_set_ProtectionLevel_Price_Blank(PATTERN_BASE_PRICE, patternList[index][2]);

        } else {    // PRO - SOLID COLOUR
            // get the index of the currently selected outer layer and inner layer solid colour blanks
            index = getCurrentBlankIndex(view_OuterLayer, solidColourList);
            index_inner = getCurrentBlankIndex(view_InnerLayer, solidColourList_Inner);

            // set the outer layer colour/transparency
            // checking for index of 3 because we're using the full list of colours as we're dealing with the outer layer
            if(index === 3) {
                update_SolidColourLayer(OUTER_LAYER, solidColourList[index][1], true);
            } else {
                update_SolidColourLayer(OUTER_LAYER, solidColourList[index][1], false);
            }

            // set the inner layer colour and its transparency if clear is selected
            // checking for index of 2 because we're using the reduced list of colours as we're dealing with an actual inner layer
            if(index_inner === 2) {
                // optional - make sure we don't make the inner layer transparent if the outer layer is also transparent as we lose all definition
                if(view_OuterLayer === solidColourList[3][0]) {
                    update_SolidColourLayer(INNER_LAYER, solidColourList_Inner[index_inner][1], false);
                } else {
                    update_SolidColourLayer(INNER_LAYER, solidColourList_Inner[index_inner][1], true);
                }
            } else {
                update_SolidColourLayer(INNER_LAYER, solidColourList_Inner[index_inner][1], false);
            }

            // set the modals protection level, price and blank
            modal_set_ProtectionLevel_Price_Blank(UNICOLOUR_BASE_PRICE, solidColourList[index][2]);
        }
    }
}

// return the currently selected blanks index in the list
function getCurrentBlankIndex(layerToCheck, listToCheck) {
    // find out what the outer layer pattern should be
    for(let i = 0; i < listToCheck.length; i++) {
        if(layerToCheck === listToCheck[i][0]) {
            return i;
        }
    }
}

// update the specified layer with the solid colour blank passed
function update_SolidColourLayer(layer, blank, set_clear = false) {
    // set the colour and remove the texture map
    view_mouthguard.children[layer].material.color.set(blank);
    view_mouthguard.children[layer].material.map = null;

    // set the transparency of the mouthguard layer appropriately
    if (set_clear) {
        setLayerToTransparent(layer);
    } else {
        setLayerToOpaque(layer);
    }

    // set the layers properties for the shinyness effect
    if(layer === OUTER_LAYER) {
        setOuterLayerProperties(layer); 
    } else {
        setInnerLayerProperties(layer);
    }

    // update with the changes
    view_mouthguard.children[layer].needsUpdate = true;
}

// update the layer with the patterned blank passed
// function update_PatternedLayer(layer, blank, addTransparency = false) {
function update_PatternedLayer(layer, blank) {
    // set the colour to white
    view_mouthguard.children[layer].material.color.set(0xffffff);

    // handle flipping the texture horizontally if the layer is the inner one
    if(layer === INNER_LAYER) {
        // clone the texture so we can flip it in the X direction without affecting the outer layer texture
        view_mouthguard.children[layer].material.map = blank.clone();

        // flip the texture in the X direction
        view_mouthguard.children[layer].material.map.wrapS = THREE.RepeatWrapping;
        view_mouthguard.children[layer].material.map.repeat.x = -1;

        // // HACK: make the inner layer slightly transparent - this is to try and make the textures with transparent areas in them, look better
        // if(addTransparency) {
        //     view_mouthguard.children[layer].material.transparent = true;
        //     view_mouthguard.children[layer].material.opacity = 0.9;
        // } 

    } else {
        // OUTER LAYER
        // set the texture
        view_mouthguard.children[layer].material.map = blank;
    }

    // update the changes to the material map
    view_mouthguard.children[layer].material.map.needsUpdate = true;

    // set the layer properties to shiny for both INNER and OUTER layers used as this looks better
    setOuterLayerProperties(layer);  
}

// set the outer layer properties for the passed in layer
function setOuterLayerProperties(layer) {
    view_mouthguard.children[layer].material.clearcoat = materialProperties.OL_materialClearcoat;
    view_mouthguard.children[layer].material.clearcoatRoughness = materialProperties.OL_materialClearcoatRoughness;
    view_mouthguard.children[layer].material.roughness = materialProperties.OL_materialRoughness; 
}

// set the inner layer properties for the passed in layer
function setInnerLayerProperties(layer) {
    view_mouthguard.children[layer].material.clearcoat = materialProperties.IL_materialClearcoat;
    view_mouthguard.children[layer].material.clearcoatRoughness = materialProperties.IL_materialClearcoatRoughness;
    view_mouthguard.children[layer].material.roughness = materialProperties.IL_materialRoughness;
}

// handle the settings for the textures that have transparency in them
function view_handleTexturesWithTransparency(layer, index) {
    // handle the textures with transparency in them by linking the correct alphaMapID with the correct pattern index
    let alphaMapID = null;

    switch(index) {
        case ICEBERG_PATTERN_ID:
            alphaMapID = 0;
            break;
        case G_CLEAR_PATTERN_ID:
            alphaMapID = 1;
            break;
        case SAPPHIRE_PATTERN_ID:
            alphaMapID = 2;
            break;
        case DAZZLE_PATTERN_ID:
            alphaMapID = 3;
            break;
        case LADYBIRD_PATTERN_ID:
            alphaMapID = 4;
            break;
        case THUNDER_PATTERN_ID:
            alphaMapID = 5;
            break;
        case COSMOS_PATTERN_ID:
            alphaMapID = 6;
            break;
        case BLUSH_PATTERN_ID:
            alphaMapID = 7;
            break;
        case AQUAMARINE_PATTERN_ID:
            alphaMapID = 8;
            break;
        case PEPPERMINT_PATTERN_ID:
            alphaMapID = 9;
            break;
        case EMERALD_PATTERN_ID:
            alphaMapID = 10;
            break;
        default:
            alphaMapID = null;
            break;
    }
  
    if(alphaMapID !== null) {
        // add the alphaMap and transparent settings for the layer so transparency can be handled
        view_mouthguard.children[layer].material.alphaMap = view_alphaMapList[alphaMapID];
        view_mouthguard.children[layer].material.transparent = true;
        view_mouthguard.children[layer].material.opacity = 1;

        // update the material
        view_mouthguard.children[layer].material.needsUpdate = true;
        // view_mouthguard.children[layer].material.map.needsUpdate = true;
    }
}

// disable the alphaMap
function disableLayersAlphaMap() {
    // remove the alphaMap and transparency from the inner layer
    view_mouthguard.children[INNER_LAYER].material.alphaMap = null;
    view_mouthguard.children[INNER_LAYER].material.transparent = false;
    view_mouthguard.children[INNER_LAYER].material.opacity = 1;
    view_mouthguard.children[INNER_LAYER].material.needsUpdate = true;


    // remove the alphaMap and transparency from the outer layer
    view_mouthguard.children[OUTER_LAYER].material.alphaMap = null;
    view_mouthguard.children[OUTER_LAYER].material.transparent = false;
    view_mouthguard.children[OUTER_LAYER].material.opacity = 1;
    view_mouthguard.children[OUTER_LAYER].material.needsUpdate = true;
}

// set the modal to reflect that there is no inner layer
function modal_setNoInnerLayerHeader() {
    // turn off the header previous and next buttons as we have no inner layer
    modalHeaderPreviousBtn.style.display = "none";
    modalHeaderNextBtn.style.display = "none";

    // as the inner layer is matching the outer layer - state that there is no inner layer,
    modalHeaderInnerColourValue.innerHTML = "No Inner Layer";
}

function modal_setInnerLayerColourHeader() {
    // turn on the header previous and next buttons as we have now have a unique inner layer
    modalHeaderPreviousBtn.style.display = "block";
    modalHeaderNextBtn.style.display = "block";

    // find out what the current inner layer colour is and set the correct string in the modal header
    for(let i = 0; i < solidColourList_Inner.length; i++) {
        if(view_InnerLayer === solidColourList_Inner[i][0]) {
            modalHeaderInnerColourValue.innerHTML = solidColourList_Inner[i][2];
            return;
        }
    }
}

// set the modals protection level, price and blank being used
function modal_set_ProtectionLevel_Price_Blank(price, blank) {
    // display the protection level and price of the mouthguard
    // NEW - setting up the modal having both protection toggle buttons present 
    // modalProtectionValue.innerHTML = getProtectionLevelForMouthguard();  OLD
    // modalHighProtectionToggle.innerHTML = getProtectionLevelForMouthguard();
    // modalProProtectionToggle.innerHTML = getProtectionLevelForMouthguard();
    modalHighProtectionToggle.innerHTML = "High";
    modalProProtectionToggle.innerHTML = "Pro";
  
    // modalPriceValue.innerHTML = "<strong>£" + getCalculatedPriceForMouthguard(price);
    modalPriceValue.innerHTML = "<strong>" + getCalculatedPriceForMouthguard(price);

    // update to the correct blank label
    modalOuterColourValue.innerHTML = "<strong>" + blank;
}

// setup the modals styles and sizes
function modal_setModalStylesAndSizes() {
    // handle the header inner colour styling for the modal
    modalHeaderInnerColourValue.style.width = "80%";
    modalHeaderInnerColourValue.style.textAlign = "center";
    modalHeaderInnerColourValue.style.margin = "0 auto";
    modalHeaderInnerColourValue.style.textTransform = "uppercase";

    // handle generic text styling stuff for the modal
    modalOuterColourValue.style.width = "80%";
    modalOuterColourValue.style.textAlign = "center";
    modalOuterColourValue.style.padding = "1em 0 0.25em 0";
    modalOuterColourValue.style.margin = "0 auto";
    modalOuterColourValue.style.textTransform = "uppercase";




    // NEW - setting up the modal having both protection toggle buttons present
    modalHighProtectionToggle.style.display = "inline-block";
    modalHighProtectionToggle.style.border = "solid rgba(0, 0, 0, 0.1) 2px";
    modalHighProtectionToggle.style.borderRadius = "10px 0 0 10px";
    modalHighProtectionToggle.style.width = "100px";
    modalHighProtectionToggle.style.textAlign = "center";
    modalHighProtectionToggle.style.padding = "0";
    modalHighProtectionToggle.style.paddingLeft = "10px";
    modalHighProtectionToggle.style.paddingRight = "10px";
    modalHighProtectionToggle.style.margin = "0 auto";
    modalHighProtectionToggle.style.marginBottom = "5px";

    modalProProtectionToggle.style.display = "inline-block";
    modalProProtectionToggle.style.border = "solid rgba(0, 0, 0, 0.1) 2px";
    modalProProtectionToggle.style.borderRadius = "0 10px 10px 0";
    modalProProtectionToggle.style.width = "100px";
    modalProProtectionToggle.style.textAlign = "center";
    modalProProtectionToggle.style.padding = "0";
    modalProProtectionToggle.style.paddingLeft = "10px";
    modalProProtectionToggle.style.paddingRight = "10px";
    modalProProtectionToggle.style.margin = "0 auto";
    modalProProtectionToggle.style.marginBottom = "5px";

    modal_UpdateProtectionLevelBtnsStateChanges();  


  

    // modalProtectionValue.style.width = "80%"; OLD
    // modalProtectionValue.style.textAlign = "center"; OLD
    // modalProtectionValue.style.padding = "0"; OLD
    // modalProtectionValue.style.margin = "0 auto"; OLD

    modalPriceValue.style.textAlign = "center";
    modalPriceValue.style.padding = "0 0 0.25em 0";
    modalPriceValue.style.margin = "0 auto";

    // scale the font size based on screen width
    if (window.innerWidth < 320) {
        modalHeaderInnerColourValue.style.fontSize = "1.25rem";
        modalTurntableText.style.fontSize = "1.15rem";
        modalOuterColourValue.style.fontSize = "1.25rem";
        // modalProtectionValue.style.fontSize = "1.15rem"; OLD
        modalHighProtectionToggle.style.fontSize = "1.15rem";
        modalProProtectionToggle.style.fontSize = "1.15rem";      
        modalPriceValue.style.fontSize = "1.35rem";
    } else if (window.innerWidth < 411) {
        modalHeaderInnerColourValue.style.fontSize = "1.25rem";
        modalTurntableText.style.fontSize = "1.25rem";
        modalOuterColourValue.style.fontSize = "1.5rem";
        // modalProtectionValue.style.fontSize = "1.4rem"; OLD
        modalHighProtectionToggle.style.fontSize = "1.4rem";
        modalProProtectionToggle.style.fontSize = "1.4rem";
        modalPriceValue.style.fontSize = "1.6rem";
    } else if (window.innerWidth < 600) {
        modalHeaderInnerColourValue.style.fontSize = "1.75rem";
        modalTurntableText.style.fontSize = "1.25rem";
        modalOuterColourValue.style.fontSize = "1.75rem";
        // modalProtectionValue.style.fontSize = "1.65rem"; OLD
        modalHighProtectionToggle.style.fontSize = "1.65rem";
        modalProProtectionToggle.style.fontSize = "1.65rem";      
        modalPriceValue.style.fontSize = "1.85rem";
    } else {
        modalHeaderInnerColourValue.style.fontSize = "2.25rem";
        modalTurntableText.style.fontSize = "1.5rem";
        modalOuterColourValue.style.fontSize = "2.25rem";
        // modalProtectionValue.style.fontSize = "2.15rem";
        modalHighProtectionToggle.style.fontSize = "2.15rem";
        modalProProtectionToggle.style.fontSize = "2.15rem";      
        modalPriceValue.style.fontSize = "2.35rem";
    }

    // display the green basket by default
    displayDarkBlueBasket();

    // display the red 'close' cross by default
    displayDarkBlueCross();    
}